import { render } from "./DashboardCard.vue?vue&type=template&id=f8052604&scoped=true&ts=true"
import script from "./DashboardCard.vue?vue&type=script&lang=ts"
export * from "./DashboardCard.vue?vue&type=script&lang=ts"

import "./DashboardCard.vue?vue&type=style&index=0&id=f8052604&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8052604"]])

export default __exports__